// @ts-ignore
import { createConfig, http } from 'wagmi';
import useChains from './useChains';
import { Chain } from 'viem';

const useConfig = () => {
  const { evmChains } = useChains();

  const _evmChains = evmChains
    .map(chain => {
      return chain.chain;
    })
    .map(m => {
      if (m.id == 1) {
        return {
          ...m,
          rpcUrls: {
            default: {
              http: ['https://rpc.ankr.com/eth'],
            },
          },
        };
      }

      return m as Chain;
    });

  // @ts-ignore
  const wagmiConfig = createConfig({
    chains: _evmChains.map(item => item) as any,
    transports: Object.fromEntries(
      _evmChains
        .map(chain => {
          return chain?.id;
        })
        .map(key => [key, http()])
    ),
  });

  return {
    config: wagmiConfig,
  };
};

export default useConfig;
